import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useConfig } from 'config/ConfigContext';

import style from './style.scss';

const unSupportedStates = {
  CO: 'Colorado',
  CT: 'Connecticut',
  IA: 'Iowa',
  MA: 'Massachusetts',
  NY: 'New York',
  WV: 'West Virginia',
  NH: 'New Hampshire',
  VT: 'Vermont',
  NV: 'Nevada',
};

const Popup = ({ type = null, handleAbort, data = null }) => {
  const appConfig = useConfig();
  return (
  <div className={style['smarty-ui']}>
    <div className={style['smarty-popup']}>
      <div className={cn(style['smarty-popup-header'], type === 1 && style['smarty-popup-missing-input-header'], (type === 2 || type === 3 || type === 4) && style['smarty-popup-invalid-header'])}>
        {type === 1 && 'You didn\'t enter enough information'}
        {type === 2 && 'You entered an unknown address'}
        {type === 3 && 'P.O Box address is not allowed'}
        {type === 4 && `Currently we do not accept loan applications for residents of the state of ${unSupportedStates[data.state]}`}
      </div>
      <div className={style['smarty-popup-typed-address']}>
        { type !== 4 && `${data.address || ''} ${data.city || ''} ${data.state || ''} ${data.zipcode || ''}`}
      </div>
      <div className={style['smarty-choice-alt']} style={{ justifyContent: (!appConfig.smartyStreetEnforce && (type !== 1 && type !== 4)) ? 'space-between' : 'center' }}>
        { (type !== 1 && type !== 4 && !appConfig.smartyStreetEnforce) && <div className={cn(style['smarty-choice'], style['smarty-choice-abort'], style['smarty-abort'])} onClick={handleAbort}>Use this address anyway</div> }
        <div className={cn(style['smarty-choice'], style['smarty-choice-abort'], style['smarty-abort'])} onClick={handleAbort}>Go back</div>
      </div>
    </div>
  </div>
);

};

Popup.propTypes = {
  handleAbort: PropTypes.func.isRequired,
  type: PropTypes.number,
  data: PropTypes.object,
};

export default Popup;
